import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-documentation',
    imports: [],
    templateUrl: './documentation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './documentation.component.scss'
})
export class DocumentationComponent {

}
